import { takeEvery, fork, put, all, call } from "redux-saga/effects";

import {
    GET_VARIABLE,
  } from "./actionTypes";

import { getVariables, setVariables, errorVariables } from "./actions";

import axios from "axios";

import { integerBetween } from "../../Libs/CustomMethods/customMethods";
import { getErrorMessage } from "../../Libs/SagaUtils/sagaUtils";

function* getDataIndex({ payload: { variables } }) {
  try {
    const response = yield call(
      axios.get,
      `/variables/${
        (variables || '')
      }`
    );
    let status = response?.status;
    let data = response?.data;
    if (integerBetween(status, 200, 299)) {
      yield put(setVariables(data.data));
    } else {
      throw data;
    }
  } catch (error) {
    let message = getErrorMessage(error);
    yield put(errorVariables(message));
  }
}

export function* watchGetDataIndex() {
  yield takeEvery(GET_VARIABLE, getDataIndex);
}

function* authSaga() {
  yield all([
    fork(watchGetDataIndex),
  ]);
}

export default authSaga;
